import axios from "axios";
import Cookies from "js-cookie";
import { getPreferredCurrency } from "../currency";

// Create a reusable Axios instance
const apiClient = axios.create({
    baseURL: "https://alltimetest7.inter-netsys.com",
    timeout: 10000000,
    withCredentials: true,
});

const AXIOS_CONFIG_KEYS = new Set([
    "baseURL",
    "data",
    "headers",
    "maxBodyLength",
    "maxContentLength",
    "method",
    "onDownloadProgress",
    "onUploadProgress",
    "params",
    "responseType",
    "signal",
    "timeout",
    "transformRequest",
    "transformResponse",
    "validateStatus",
    "withCredentials",
]);

/**
 * Merge default headers with custom headers
 * @param {Object} customHeaders - Optional custom headers
 * @returns {Object} - Combined headers
 */
const getHeaders = (customHeaders = {}) => {
    return {
        "Content-Type": "application/json",
        ...customHeaders,
    };
};

const normalizeRequestOptions = (options = {}) => {
    if (!options || typeof options !== "object" || Array.isArray(options)) {
        return { headers: getHeaders() };
    }

    const looksLikeAxiosConfig = Object.keys(options).some(
        (key) => AXIOS_CONFIG_KEYS.has(key)
    );

    if (!looksLikeAxiosConfig) {
        return {
            headers: getHeaders(options),
        };
    }

    const { headers = {}, ...axiosConfig } = options;
    return {
        ...axiosConfig,
        headers: getHeaders(headers),
    };
};

/**
 * Get preferred language from cookies
 * @returns {string}
 */
const getPreferredLanguage = () => {
    return Cookies.get("preferred_language") || "en";
};

const canAttachPreferenceFields = (data) => {
    if (!data || typeof data !== "object" || Array.isArray(data)) {
        return false;
    }

    if (typeof FormData !== "undefined" && data instanceof FormData) {
        return false;
    }

    if (typeof URLSearchParams !== "undefined" && data instanceof URLSearchParams) {
        return false;
    }

    return true;
};

const addRequestPreferences = (data) => {
    if (!canAttachPreferenceFields(data)) {
        return data;
    }

    return {
        ...data,
        preferred_language: data.preferred_language || getPreferredLanguage(),
        preferred_currency: data.preferred_currency || getPreferredCurrency(),
    };
};
/**
 * Perform a GET request
 */
export const axiosGet = async (url, params = {}, options = {}) => {
    try {
        const requestConfig = normalizeRequestOptions(options);
        const response = await apiClient.get(url, {
            ...requestConfig,
            params: {
                preferred_language: getPreferredLanguage(),
                preferred_currency: getPreferredCurrency(),
                ...params,
            },
        });
        return response.data;
    } catch (error) {
        handleAxiosError(error);
    }
};

/**
 * Perform a POST request
 */
export const axiosPost = async (url,data, options = {}) => {
    data = addRequestPreferences(data);

    if(typeof data !== 'string')
    {
        data = JSON.stringify(data);
    }

    try {
        const requestConfig = normalizeRequestOptions(options);
        const response = await apiClient.post(url, data, {
            ...requestConfig,
        });
        return response;
    } catch (error) {
        console.log("error in axios post",error);

      handleAxiosError(error);

    }
};

/**
 * Upload a file and return the URL generated by Frappe.
 */
export const axiosUploadFile = async (url, file, options = {}) => {
    const formData = new FormData();
    formData.append("file", file);

    const apiKey = Cookies.get("api_key");
    const apiSecret = Cookies.get("api_secret");
    const authorization =
        apiKey && apiSecret ? `token ${apiKey}:${apiSecret}` : null;

    const csrfToken =
        window.frappe?.csrf_token ||
        window.$?.('meta[name="csrf-token"]').attr("content");

    try {
        const response = await apiClient.post(url, formData, {
            ...options,
            headers: {
                ...(csrfToken ? { "X-Frappe-CSRF-Token": csrfToken } : {}),
                ...(authorization ? { Authorization: authorization } : {}),
                ...(options.headers || {}),
            },
        });
        const responseData = response.data;

        if (responseData?.exception || responseData?.exc_type) {
            const isPermissionError =
                responseData.exc_type === "PermissionError" ||
                String(responseData.exception || "").includes("PermissionError");
            throw new Error(
                isPermissionError
                    ? "File upload is not permitted for guest users"
                    : responseData.message || "The file upload failed"
            );
        }
        const fileUrl = responseData?.message?.file_url;

        if (!fileUrl) {
            throw new Error("The upload did not return a file URL");
        }

        return fileUrl;
    } catch (error) {
        handleAxiosError(error);
    }
};

/**
 * Perform a PUT request
 */
export const axiosPut = async (url, data, options = {},  params = {}) => {
    try {
        data = addRequestPreferences(data);

        if(typeof data !== 'string')
        {
            data = JSON.stringify(data);
        }

        const requestConfig = normalizeRequestOptions(options);
        const response = await apiClient.put(url, data, {
            ...requestConfig,
        });
        return response;
    } catch (error) {
        handleAxiosError(error);
    }
};

/**
 * Perform a DELETE request
 */
export const axiosDelete = async (url, params = {}, options = {}) => {
    try {
        const requestConfig = normalizeRequestOptions(options);
        const response = await apiClient.delete(url, {
            // params: {
            //     preferred_language: getPreferredLanguage(),
            //     ...params,
            // },
            ...requestConfig,
        });
        return response;
    } catch (error) {
        handleAxiosError(error);
    }
};

/**
 * Handle Axios errors
 */
  const handleAxiosError = (error) => {
    const Lang = Cookies.get("preferred_language") || "en";

    if (error.code === "ERR_NETWORK") {
        throw new Error(Lang==="ar"? "لا يوجد اتصال بالإنترنت. يُرجى التحقق من شبكتك.":
            "No internet connection. Please check your network.");
    }
  
    if (error.response) {
      const responseData = error.response.data;  
      if (responseData?.result) {
        // console.log(responseData.result)
        //     var message = "";
        // responseData.result.map((err, idx) => 
        //                 message += err.ErrorMessage + "\n"
        //     );
        //     console.log("message",message);
                    

        throw new Error(responseData.result);
        

      } else {
        throw new Error(responseData?.message || (Lang==="ar"?"حدث خطأ. يرجى المحاولة مرة أخرى لاحقًا.": "An Error Occured"));
      } 
      }
  
    throw new Error(error.message || (Lang==="ar"?"حدث خطأ. يرجى المحاولة مرة أخرى لاحقًا.": "An Error Occured"));
  };
  
